import React from 'react';
import cls from 'classnames';

import type {
  OverridableComponent,
  OverridableComponentProps,
} from '../OverridableComponent';
import { Box } from '../Box';

import classes from './CardContent.scss';

export interface ICardContentProps extends React.ComponentProps<typeof Box> {
  disableSideGutters?: boolean;
}

// eslint-disable-next-line react/display-name
export const CardContent = React.forwardRef(
  (
    props: OverridableComponentProps<ICardContentProps, 'div'>,
    ref: React.Ref<HTMLDivElement>,
  ) => {
    const { children, className, disableSideGutters, ...rest } = props;

    return (
      <Box
        ref={ref}
        direction="vertical"
        className={cls(classes.root, className)}
        padding={disableSideGutters ? undefined : 'SP0 SP5'}
        {...rest}
      >
        {children}
      </Box>
    );
  },
) as OverridableComponent<ICardContentProps, 'div'>;

CardContent.displayName = 'wui/CardContent';
